// @ts-nocheck
import { Trans } from '@lingui/react'
import classNames from 'clsx'

import { ERxMedicationType } from 'views/consts/cart'

const MedicationType = ({ eRxMedicationType, activeSubstance, pzn, isERx }) => {
  const productNameClass = classNames({
    'u-font-weight--bold': !isERx,
  })

  switch (eRxMedicationType) {
    case ERxMedicationType.PZN:
      return (
        <div className="u-color--grey">
          <Trans id="product.erx.medicationType.pzn" /> {pzn}
        </div>
      )
    case ERxMedicationType.ACTIVE_SUBSTANCE: {
      const activeSubstanceLabel =
        activeSubstance &&
        `${activeSubstance.name} ${activeSubstance.strength} ${activeSubstance.unit}`
      return (
        <span className={productNameClass}>
          {activeSubstanceLabel || (
            <Trans id="product.erx.medicationType.activeSubstance" />
          )}
        </span>
      )
    }
    case ERxMedicationType.COMPOSITE:
      return (
        <span className={productNameClass}>
          <Trans id="product.erx.medicationType.composite" />
        </span>
      )
    case ERxMedicationType.FREETEXT:
      return (
        <span className={productNameClass}>
          <Trans id="product.erx.medicationType.freetext" />
        </span>
      )
    default:
      return null
  }
}

export default MedicationType
